import { SidebarItem } from '../SidebarItem';
import { LogoutIcon } from './styles';

interface ILogoutSidebarItemProps {
  isShrunken: boolean;
  handleSignOut: () => Promise<void>;
}

export const LogoutSidebarItem = ({
  isShrunken,
  handleSignOut,
}: ILogoutSidebarItemProps): JSX.Element => {
  return (
    <SidebarItem
      title="Log out"
      dataCy="button-logout"
      isShrunken={isShrunken}
      onClick={() => {
        void handleSignOut();
      }}
      type="button"
      icon={<LogoutIcon />}
    />
  );
};
